import { render, staticRenderFns } from "./SlidoFrame.vue?vue&type=template&id=18be2efd&"
import script from "./SlidoFrame.vue?vue&type=script&lang=js&"
export * from "./SlidoFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports